import { Crown, Pencil, Eye } from "lucide-react";
import { classNames } from "@/lib/format";

export const ROLE_META = {
  owner: { label: "Owner", icon: Crown, cls: "bg-[hsl(var(--amber)/0.15)] text-[hsl(var(--amber))]", desc: "Full access, member management and settings." },
  editor: { label: "Editor", icon: Pencil, cls: "bg-primary/10 text-primary", desc: "Browse, save, swipe, track creators and edit shared lists." },
  viewer: { label: "Viewer", icon: Eye, cls: "bg-muted text-muted-foreground", desc: "Read-only: browse creators, lists, Compare and Trend views." },
};

export default function RoleBadge({ role, className, testid }) {
  const m = ROLE_META[role] || ROLE_META.editor;
  const Icon = m.icon;
  return (
    <span className={classNames("inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider rounded-full px-2 py-0.5", m.cls, className)} data-testid={testid}>
      <Icon className="h-3 w-3" /> {m.label}
    </span>
  );
}
